import { memo } from 'react';
import { Modal } from '@mui/material';

type ImageLightboxProps = {
    open: boolean;
    onClose: () => void;
    imageUrl: string;
    alt: string;
};

function ImageLightbox({ open, onClose, imageUrl, alt }: ImageLightboxProps) {
    return (
        <Modal
            open={open}
            onClose={onClose}
            slotProps={{ backdrop: { sx: { backgroundColor: 'rgba(0,0,0,0.9)' } } }}
            sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', p: 2 }}
        >
            <img
                src={imageUrl}
                alt={alt}
                className='max-w-full max-h-[90vh] object-contain rounded-xl shadow-2xl'
                referrerPolicy='no-referrer'
                onClick={(e) => e.stopPropagation()}
            />
        </Modal>
    );
}

export default memo(ImageLightbox);
